import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Image, Modal, Popup, Segment,Message} from 'semantic-ui-react';
import * as placeholder from "../../assets/placeholderImage.png";
import ReportContainer from "../../containers/report_container";
import AddNewMeter from "./add_new_meter";
import AddNewReading from './add_new_reading';
import {uploadMeterDetails,getOldMeterDetails} from "../../data/report_api";
import Loader from "../universal/loader";
import { handleReadingUpdate } from '../../actions/report_action';
import ImageUploadDropzone from './image_upload_dropzone';

const uuidv1 = require('uuid/v1');

class Meters extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showMetersSection: false,
            inspectionType: undefined,
            readingValue: undefined,
            showCOReadingEdit: undefined,
            showCIReadingEdit: undefined,
            supplierName: undefined,
            location: undefined,
            serialNumber: undefined,
            images: {},
            failedUploads:[],
            imgErrorMsg:undefined,
            errorMsg:undefined,
            absenceInfoChanged:false,
            meterHistory:undefined,
            meterHistoryLoading:false
        }
    }

    componentWillMount() {
        this.setState({
            showMetersSection: this.props.showMeters,
            inspectionType: this.props.reportDetails['inspection_type']
        })
    }
    
    uploadMeters = () => {

        this.setState({isSaving:true,errorMsg:undefined,imgErrorMsg:undefined});

        let reportUpdateMeters = JSON.parse(JSON.stringify(this.props.updateMeters));
        let reportUpdateMetersList = reportUpdateMeters.meters;
        let images = [];
        for (let i = 0; i < reportUpdateMetersList.length; i++) {
            reportUpdateMetersList[i]['readings'] = []
        }
        let reportUpdateReadingsList = JSON.parse(JSON.stringify(this.props.updateMeters.readings));
        for (let i = 0; i < reportUpdateReadingsList.length; i++) {
            if (reportUpdateReadingsList[i]['ci_image']) {
                const ciImage = this.props.updateMeters.readings[i]['ci_image'];
                if (!ciImage['image_path']) {
                    images.push(ciImage);
                }
                reportUpdateReadingsList[i]['ci_image'] = {id: reportUpdateReadingsList[i]['ci_image']['id']}
            }
            if (reportUpdateReadingsList[i]['co_image']) {
                const coImage = this.props.updateMeters.readings[i]['co_image'];
                if (!coImage['image_path']) {
                    images.push(coImage);
                }
                reportUpdateReadingsList[i]['co_image'] = {id: reportUpdateReadingsList[i]['co_image']['id']}
            }
        }

        reportUpdateMeters['meters'] = reportUpdateMetersList;
        reportUpdateMeters['readings'] = reportUpdateReadingsList;
        reportUpdateMeters["meter_absence_info"] = this.props.reportDetails["meter_absence_info"]

        if (reportUpdateMeters.meters.length > 0 || reportUpdateMeters.readings.length > 0 || images.length > 0 || this.state.absenceInfoChanged) {
            let reportType = this.props.reportDetails['inspection_type'];
            const reportTypes = this.props.other_template? "both": reportType === 'co' ? "co" : "ci";

            uploadMeterDetails(reportTypes, reportUpdateMeters).then((response) => {
                if (response.success) {
                    if (images.length > 0) {
                        for (let i = 0; i < images.length; i++) {
                            const formData = new FormData();
                            formData.append("id", images[i].id);
                            formData.append("file", images[i].file);
                            if(i === images.length-1){
                                this.props.uploadImages(formData, this.completeCallBack);
                            }
                            else {
                                this.props.uploadImages(formData, this.successFn);
                            }
                        }
                    }
                    else {
                        this.completeCallBack(response);
                    }
                }
                else {
                    {this.setState({errorMsg:response.statusMessage || "There was an error while saving, please try again",isSaving:false})}
                }
            }).catch((e) => {
                {this.setState({errorMsg:"There was an error while saving, please try again",isSaving:false})}
            });
        }
        else {
            this.exitWindow();
        }
    };

    successFn = (response, image) => {
        if (!response.success) {
            this.setState({failedUploads:[...this.state.failedUploads, image]})
        }
    };

    exitWindow = () =>{
        this.props.resetDataQueuedInAPI('meters');
        this.setState({isSaving:false});
        this.props.handleClose();
    }

    completeCallBack = (response,image) => {

        if (response && !response.success && image) {
            let error = undefined
            let err = response.statusMessage
            if (err.response) {
                error = err.response.data.error || "An error occurred on the server.";
            } else if (err.request) {
                error = "Network error: Please check your internet connection.";
            } else {
                error = err.message || "An unknown error occurred.";
            }
            this.setState({failedUploads:[...this.state.failedUploads, image], isSaving:false, imgErrorMsg:error})
        } else {
            this.props.resetDataQueuedInAPI('meters');
            this.setState({isSaving:false});
            this.props.handleClose();
        }
    };

    retryImageUpload = () =>{
        let images = [...this.state.failedUploads]
        console.log(images)
        this.setState({isSaving:true,imgErrorMsg:undefined,failedUploads:[]})
        if (images.length > 0) {
            for (let i = 0; i < images.length; i++) {
                if(i === images.length-1){
                    this.props.uploadImages(images[i], this.completeCallBack);
                }
                else {
                    this.props.uploadImages(images[i], this.successFn);
                }
            }
        }
        else {
            this.completeCallBack({success:true});
        }

    }
    handleReadingDelete = (meterIndex, readingIndex, reading) => {
        this.props.handleReadingDeleteInMeter(meterIndex, readingIndex, reading);
    };

    handleMeterDelete = (meterObject) => {
        this.props.deleteMeterInReport(meterObject);
    };

    updateReading = (meterIndex, readingIndex, reading) => {
        if (!reading['action']) {
            reading['action'] = 'update'
        }

        if (this.props.other_template) {
            if (this.state.showCOReadingEdit) {
                reading['co_value'] = this.state.readingValue;
            }
            else {
                reading['ci_value'] = this.state.readingValue;
            }
         }
        else {
            if (this.state.inspectionType === 'co') {
                reading['co_value'] = this.state.readingValue;
            }
            else {
                reading['ci_value'] = this.state.readingValue;
            }
        }
        this.props.handleReadingUpdate(meterIndex, readingIndex, reading);
    };

    updateMeterDetail = (meter, section, insType) => {
        if (!meter['action']) {
            meter['action'] = 'update';
        }

        if (this.props.other_template)
        {
            if (section === 1) {
                if (this.state.showCOSupplierEdit) {
                    meter['co_supplier'] = this.state.supplierName;
                }
                else {
                    meter['ci_supplier'] = this.state.supplierName;
                }
            }
            else if (section === 2) {
                if (this.state.showCOSnoEdit) {
                    meter['co_sno'] = this.state.serialNumber;
                }
                else {
                    meter['ci_sno'] = this.state.serialNumber;
                }
            }
            else if (section === 3) {
                if (this.state.showCOLocationEdit) {
                    meter['co_location'] = this.state.location;
                }
        
                else {
                    meter['ci_location'] = this.state.location;
                }
            }
        }
        else
        {    
            if (section === 1) {
                if (insType === 'co') {
                    meter['co_supplier'] = this.state.supplierName;
                }
                else {
                    meter['ci_supplier'] = this.state.supplierName;
                }
            }
            else if (section === 2) {
                if (insType === 'co') {
                    meter['co_sno'] = this.state.serialNumber;
                }
                else {
                    meter['ci_sno'] = this.state.serialNumber;
                }
            }
            else if (section === 3) {
                if (insType === 'co') {
                    meter['co_location'] = this.state.location;
                }
                else {
                    meter['ci_location'] = this.state.location;
                }
            }
        }
        this.props.updateMeterInReport(meter);
    };

    updateReadingImage = (file, meterIndex, readingIndex, readingDetail) => {
        let fr = new FileReader();
        let image = {};
        if (file) {
            fr.onload = (e) => {
                file['dataURL'] = e.target.result;
                image = {
                    id: uuidv1(),
                    file: file,
                    dataURL: e.target.result
                };
                this.setState({images: image});
            };
            fr.readAsDataURL(file);
        }
        if (!readingDetail.action) {
            readingDetail['action'] = 'update'
        }
        if (this.props.other_template) {
            if (this.state.showCIImageEdit) {
                setTimeout(() => {
                    readingDetail['ci_image'] = this.state.images;
                    this.props.handleReadingUpdate(meterIndex, readingIndex, readingDetail);
                    this.setState({ showCIImageEdit: undefined, showCOImageEdit: undefined })
                }, 1000);
            }
            else {
                setTimeout(() => {
                    readingDetail['co_image'] = this.state.images;
                    this.props.handleReadingUpdate(meterIndex, readingIndex, readingDetail);
                    this.setState({ showCIImageEdit: undefined, showCOImageEdit: undefined })
                }, 1000);
            }
        }
        else {
            if (this.state.inspectionType !== 'co') {
                setTimeout(() => {
                    readingDetail['ci_image'] = this.state.images;
                    this.props.handleReadingUpdate(meterIndex, readingIndex, readingDetail);
                    this.setState({ showCIImageEdit: undefined, showCOImageEdit: undefined })
                }, 1000);
            }
            else {
                setTimeout(() => {
                    readingDetail['co_image'] = this.state.images;
                    this.props.handleReadingUpdate(meterIndex, readingIndex, readingDetail);
                    this.setState({ showCIImageEdit: undefined, showCOImageEdit: undefined })
                }, 1000);
            }
        }

    };


    render() {
        const meters = this.props.reportDetails['meters'];
        const inspectionType = this.props.reportDetails['inspection_type'];
        let water = false;
        let electric = false;
        let gas = false;

        for (const meter of meters) {
            const name = meter.name.toLowerCase();
            if (!water && name.includes("water")) water = true;
            if (!electric && name.includes("electric")) electric = true;
            if (!gas && name.includes("gas")) gas = true;
        }

        const missing = [];
        if (!water) missing.push("Water");
        if (!gas) missing.push("Gas");
        if (!electric) missing.push("Electricity");
        return (<Segment>
            {this.state.isSaving && <Loader save={true}/>}
            <Modal size="large" open={this.state.showMetersSection} onClose={(e) => {
                this.uploadMeters();
            }}>
                <Modal.Content style={{minHeight: '500px', overflowY: 'scroll'}}>
                    <Header floated="right"><Icon className="icon-button" name="save" onClick={(e) => {
                        this.uploadMeters();
                    }}/></Header>
                    <Modal.Description>
                        <Header as='h2' textAlign='center'>
                            Meters
                        </Header>
                       <Message style={{ maxHeight: "300px", overflowY: "auto" }}> <Message.Header>Check Meter History <Popup wide="very"
                            content="Use this to quickly check meter locations while at the property. Will display every meter from the previous 5 reports."
                            trigger={<Icon name="question" />}
                            /></Message.Header><Message.Content> <hr/>
                        {!this.state.meterHistory &&  <Button loading={this.state.meterHistoryLoading} onClick={ async()=>{
                            this.setState({meterHistoryLoading:true})
                            let response = await getOldMeterDetails(this.props.reportDetails['inspection_id'])
                            if(response.meters && response.meters.length > 0 ) {
                                this.setState({meterHistory:response.meters,meterHistoryLoading:false})
                            } else {
                                this.setState({meterHistory:[{name:"No Meters Found",ci_location:"",co_location:""}],meterHistoryLoading:false})
                            }
                            }}>Get Meter History</Button>}
                            

                            {this.state.meterHistory && this.state.meterHistory.length > 0 && (
                            <div style={{ marginTop: '1em' }}>
                                {this.state.meterHistory.map((meter, index) => (
                                <div
                                    key={index}
                                    style={{
                                    padding: '10px',
                                    borderBottom: '1px solid #ddd',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    }}
                                >
                                    <div>
                                    <strong>Meter Name:</strong> {meter.name || '—'}
                                    </div>
                                    <div>
                                    <strong>Location:</strong>{' '}
                                    {`${meter.ci_location || ''} ${meter.co_location || ''}`.trim() || '—'}
                                    </div>
                                     <div>
                                    <strong>Serial Number:</strong>{' '}
                                    {`${meter.ci_sno || ''} ${meter.co_sno || ''}`.trim() || '—'}
                                    </div>
                                </div>
                                ))}
                            </div>
                            )}

                            </Message.Content></Message>
                        {this.state.errorMsg && <Message>There was an error while saving meter details, please try again.   {this.state.errorMsg} <hr/>  <Button compact onClick={this.uploadMeters}>Retry Save</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                        {this.state.failedUploads.length > 0 && <Message> {this.state.failedUploads.length} Image(s) failed to upload, try again? {this.state.imgErrorMsg}<hr/> <Button compact onClick={this.retryImageUpload}>Retry Upload</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                        {missing.length > 0 &&   <Message>
                            <Message.Header>Meter Type(s) Absent</Message.Header>
                            The following meter types are absent: <strong>{missing.join(", ")}</strong><br/>
                        Please add a meter of the missing type or explain in the text field below the reason why it is absent. Write the meter type followed by the reason and separated by commas if multiple meter types (Example:,Gas Meter: property has no gas, Water Meter: Unable to access - Agent aware etc...)
                        <br/>
                            <Form.Input fluid label="Meter Absence Reason/Comment:" onChange={(e)=>{
                                this.setState({absenceInfoChanged:true})
                                 this.props.updateMeterAbsenceInfo(e.target.value)}}
                                 value={this.props.reportDetails["meter_absence_info"]||""}></Form.Input></Message>}

                        {meters ? meters.map((meter, i) => {
                            return (<div key={meter['client_id']} className="pad-top">
                                    <Segment>
                                        <Grid stackable style={{marginTop: '0'}}>
                                            <Grid.Column width={6}>
                                                <Header
                                                    as='h2'><span>{meter['name']}</span>{(inspectionType !== 'co' || (inspectionType === 'co' && !meter['ci_location']) || this.props.other_template) &&
                                                <span className="pull-right"><Popup
                                                    trigger={<Icon name="trash" size="small"
                                                                   className="icon-button info-grey pull-right"/>}
                                                    content={<Button negative content="Confirm Delete?"
                                                                     onClick={(e) => {
                                                                         this.handleMeterDelete(meter)
                                                                     }}/>}
                                                    on="click"
                                                    position="left center"
                                                    hideOnScroll
                                                /></span>}</Header>

                                               {!this.props.other_template && <div>
                                                    <Header content="Check-In" color='teal' as='h3' textAlign="left"/>
                                                    <div>
                                                <span className="label-wide format-bold pad-all">
                                                    Supplier Name :
                                                </span>

                                                        {this.state.showCISupplierEdit === meter['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateMeterDetail(meter, 1, inspectionType)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={meter['ci_supplier']}
                                                                       placeholder="Supplier Name"
                                                                       onFocus={(e) => {
                                                                           this.setState({supplierName: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({supplierName: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showCISupplierEdit: undefined});
                                                                           this.updateMeterDetail(meter, 1, inspectionType);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showCISupplierEdit !== meter['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType !== 'co'|| this.props.other_template) {
                                                                this.setState({showCISupplierEdit: meter['client_id'], showCOSupplierEdit: undefined})
                                                            }
                                                        }}>{meter['ci_supplier'] ? meter['ci_supplier'] : "NA"}</span>}
                                                    </div>
                                                    <div>
                                                    <span className="label-wide format-bold pad-all">
                                                        Serial Number :
                                                    </span>

                                                        {this.state.showCISnoEdit === meter['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateMeterDetail(meter, 2, inspectionType)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={meter['ci_sno']}
                                                                       placeholder="Serial Number"
                                                                       onFocus={(e) => {
                                                                           this.setState({serialNumber: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({serialNumber: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showCISnoEdit: undefined});
                                                                           this.updateMeterDetail(meter, 2, inspectionType);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showCISnoEdit !== meter['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType !== 'co' || this.props.other_template) {
                                                                this.setState({showCISnoEdit: meter['client_id'], showCOSnoEdit: undefined})
                                                            }
                                                        }}>{meter['ci_sno'] ? meter['ci_sno'] : "NA"}</span>}

                                                    </div>
                                                    <div>
                                                    <span className="label-wide format-bold pad-all">
                                                        Location :
                                                    </span>
                                                        {this.state.showCILocationEdit === meter['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateMeterDetail(meter, 3, inspectionType)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={meter['ci_location']}
                                                                       placeholder="Meter Location"
                                                                       onFocus={(e) => {
                                                                           this.setState({location: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({location: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showCILocationEdit: undefined});
                                                                           this.updateMeterDetail(meter, 3, inspectionType);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showCILocationEdit !== meter['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType !== 'co' || this.props.other_template) {
                                                                this.setState({showCILocationEdit: meter['client_id'], showCOLocationEdit: undefined})
                                                            }
                                                        }}>{meter['ci_location'] ? meter['ci_location'] : "NA"}</span>}
                                                    </div>
                                                </div>}
                                                {inspectionType === 'co' && <div>
                                                    <Header content="Check-Out" color='teal' as='h3' textAlign="left"/>
                                                    <div>
                                                <span className="label-wide format-bold pad-all">
                                                    Supplier Name :
                                                </span>
                                                        {this.state.showCOSupplierEdit === meter['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateMeterDetail(meter, 1, inspectionType)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={meter['co_supplier']}
                                                                       placeholder="Supplier Name"
                                                                       onFocus={(e) => {
                                                                           this.setState({supplierName: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({supplierName: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showCOSupplierEdit: undefined});
                                                                           this.updateMeterDetail(meter, 1, inspectionType);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showCOSupplierEdit !== meter['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType === 'co') {
                                                                this.setState({showCOSupplierEdit: meter['client_id'], showCISupplierEdit:undefined})
                                                            }
                                                        }}>{meter['co_supplier'] ? meter['co_supplier'] : "NA"}</span>}
                                                    </div>
                                                    <div>
                                                    <span className="label-wide format-bold pad-all">
                                                        Serial Number :
                                                    </span>

                                                        {this.state.showCOSnoEdit === meter['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateMeterDetail(meter, 2, inspectionType)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={meter['co_sno']}
                                                                       placeholder="Serial Number"
                                                                       onFocus={(e) => {
                                                                           this.setState({serialNumber: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({serialNumber: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showCOSnoEdit: undefined});
                                                                           this.updateMeterDetail(meter, 2, inspectionType);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showCOSnoEdit !== meter['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType === 'co') {
                                                                this.setState({showCOSnoEdit: meter['client_id'], showCISnoEdit: undefined})
                                                            }
                                                        }}>{meter['co_sno'] ? meter['co_sno'] : "NA"}</span>}
                                                    </div>
                                                    <div>
                                                    <span className="label-wide format-bold pad-all">
                                                        Location :
                                                    </span>
                                                        {this.state.showCOLocationEdit === meter['client_id'] &&
                                                        <div className="ui input">
                                                            <Form onSubmit={() => {
                                                                this.updateMeterDetail(meter, 3, inspectionType)
                                                            }}>
                                                                <input style={{verticalAlign: 'middle'}} type="text"
                                                                       defaultValue={meter['co_location']}
                                                                       placeholder="Meter Location"
                                                                       onFocus={(e) => {
                                                                           this.setState({location: e.target.value})
                                                                       }}
                                                                       onChange={(e) => {
                                                                           this.setState({location: e.target.value})
                                                                       }}
                                                                       onBlur={() => {
                                                                           this.setState({showCOLocationEdit: undefined});
                                                                           this.updateMeterDetail(meter, 3, inspectionType);
                                                                       }}
                                                                       required
                                                                />
                                                            </Form>
                                                        </div>
                                                        }
                                                        {this.state.showCOLocationEdit !== meter['client_id'] &&
                                                        <span onClick={(e) => {
                                                            if (inspectionType === 'co') {
                                                                this.setState({showCOLocationEdit: meter['client_id'], showCILocationEdit:undefined})
                                                            }
                                                        }}>{meter['co_location'] ? meter['co_location'] : "NA"}</span>}
                                                    </div>
                                                </div>}
                                            </Grid.Column>
                                            <Grid.Column width={10}>
                                                {(meter['readings'] && meter['readings'].length > 0) && <Segment.Group>
                                                    {meter['readings'].map((reading, j) => {
                                                        return (
                                                            <Segment key={reading['client_id']}>
                                                                {(inspectionType === 'co' && !reading['ci_value'] || this.props.other_template) &&
                                                                <div style={{display: 'inline-block', width: '100%'}}>
                                                                    <Popup
                                                                        trigger={<Icon name="trash" size="large"
                                                                                       className="icon-button info-grey pull-right"/>}
                                                                        content={<Button negative
                                                                                         content="Confirm Delete?"
                                                                                         onClick={(e) => {
                                                                                             this.handleReadingDelete(i, j, reading)
                                                                                         }}/>}
                                                                        on="click"
                                                                        position="left center"
                                                                        hideOnScroll
                                                                    />
                                                                </div>}
                                                               {!this.props.other_template && <Grid stackable style={{marginTop: '0'}}>
                                                                    <Grid.Column  textAlign='center' width={7}>
                                                                        <Header
                                                                            as='h4'>CI {" Reading  " + (j + 1)} </Header>
                                                                        {this.state.showCIReadingEdit === reading['client_id'] &&
                                                                        <div className="ui input">
                                                                            <Form onSubmit={() => {
                                                                                this.updateReading(i, j, reading)
                                                                            }}>
                                                                                <input style={{verticalAlign: 'middle'}}
                                                                                       type="text"
                                                                                       defaultValue={reading['ci_value']}
                                                                                       placeholder="Eg. A894243"
                                                                                       autoFocus
                                                                                       onFocus={(e) => {
                                                                                           this.setState({readingValue: e.target.value})
                                                                                       }}
                                                                                       onChange={(e) => {
                                                                                           this.setState({readingValue: e.target.value})
                                                                                       }}
                                                                                       onBlur={() => {
                                                                                           this.setState({showCIReadingEdit: undefined});
                                                                                           this.updateReading(i, j, reading);
                                                                                       }}
                                                                                       required
                                                                                />
                                                                            </Form>
                                                                        </div>
                                                                        }
                                                                        {this.state.showCIReadingEdit !== reading['client_id'] &&
                                                                        <Button compact onClick={(e) => {
                                                                            if (inspectionType !== 'co' || this.props.other_template) {
                                                                                this.setState({showCIReadingEdit: reading['client_id'],showCOReadingEdit:undefined});
                                                                            }
                                                                        }}>{reading['ci_value'] ? reading['ci_value'] : "NA"}</Button>}
                                                                    </Grid.Column>
                                                                    <Grid.Column  textAlign='center' width={7}>
                                                                        <Image style={{margin:"auto"}}
                                                                            src={(reading['ci_image'] && reading['ci_image']['image_path']) ? reading['ci_image']['image_path'] : ((reading['ci_image'] && reading['ci_image']['file'] && reading['ci_image']['file']['dataURL']) ? reading['ci_image']['file']['dataURL'] : placeholder)}
                                                                            width="50px" height="50px"
                                                                            onClick={() => {
                                                                                (inspectionType !== 'co' ||this.props.other_template) && this.setState({showCIImageEdit: reading['client_id'],showCOImageEdit:undefined})
                                                                            }}/>
                                                                        {this.state.showCIImageEdit === reading['client_id'] &&
                                                                        <div>
                                                                            {<ImageUploadDropzone handlerFunction={ (file) => { this.updateReadingImage(file, i, j, reading)}} />}
                                                                        </div>}
                                                                    </Grid.Column>
                                                                    {inspectionType !== 'co' &&
                                                                    <Grid.Column  textAlign='center' width={2} className="align-y-middle">
                                                                        <Popup
                                                                            trigger={<Icon name="trash" size="large"
                                                                                           className="icon-button info-grey"/>}
                                                                            content={<Button negative
                                                                                             content="Confirm Delete?"
                                                                                             onClick={(e) => {
                                                                                                 this.handleReadingDelete(i, j, reading)
                                                                                             }}/>}
                                                                            on="click"
                                                                            position="left center"
                                                                            hideOnScroll
                                                                        />
                                                                    </Grid.Column>}
                                                                </Grid>}
                                                                {inspectionType === 'co' &&
                                                                <Grid stackable style={{marginTop: '0'}}>
                                                                    <Grid.Column  textAlign='center' width={7}>
                                                                        <Header
                                                                            as='h4'>CO {" Reading  " + (j + 1)} </Header>
                                                                        {this.state.showCOReadingEdit === reading['client_id'] &&
                                                                        <div className="ui input">
                                                                            <Form onSubmit={() => {
                                                                                this.updateReading(i, j, reading)
                                                                            }}>
                                                                                <input style={{verticalAlign: 'middle'}}
                                                                                       type="text"
                                                                                       defaultValue={reading['co_value']}
                                                                                       placeholder="Eg. A894243"
                                                                                       autoFocus
                                                                                       onFocus={(e) => {
                                                                                           this.setState({readingValue: e.target.value})
                                                                                       }}
                                                                                       onChange={(e) => {
                                                                                           this.setState({readingValue: e.target.value})
                                                                                       }}
                                                                                       onBlur={() => {
                                                                                           this.setState({showCOReadingEdit: undefined});
                                                                                           this.updateReading(i, j, reading);
                                                                                       }}
                                                                                       required
                                                                                />
                                                                            </Form>
                                                                        </div>
                                                                        }
                                                                        {this.state.showCOReadingEdit !== reading['client_id'] &&
                                                                        <Button compact onClick={(e) => {
                                                                            if (inspectionType === 'co') {
                                                                                this.setState({ showCOReadingEdit: reading['client_id'], showCIReadingEdit: undefined });
                                                                            }
                                                                        }}>{reading['co_value'] ? reading['co_value'] : "NA"}</Button>}
                                                                    </Grid.Column>
                                                                    <Grid.Column  textAlign='center' width={7}>
                                                                        <Image style={{margin:"auto"}}
                                                                            src={(reading['co_image'] && reading['co_image']['image_path']) ? reading['co_image']['image_path'] : ((reading['co_image'] && reading['co_image']['file'] && reading['co_image']['file']['dataURL']) ? reading['co_image']['file']['dataURL'] : placeholder)}
                                                                            width="50px" height="50px"
                                                                            onClick={() => {
                                                                                inspectionType === 'co' && this.setState({showCOImageEdit: reading['client_id'], showCIImageEdit:undefined})
                                                                            }}/>
                                                                        {this.state.showCOImageEdit === reading['client_id'] &&
                                                                          <div>
                                                                            {<ImageUploadDropzone handlerFunction={ (file) => { this.updateReadingImage(file, i, j, reading)}} />}
                                                                            </div>
                                                                               }
                                                                    </Grid.Column>
                                                                </Grid>}
                                                            </Segment>
                                                        )
                                                    })}
                                                </Segment.Group>}
                                            </Grid.Column>
                                            <Grid.Row> <Grid.Column width={16}> <div style={{textAlign:"center"}}><AddNewReading key={`${meter["client_id"]}${meter['readings'].length || 0}`}meterId={meter['client_id']} meterIndex={i}/></div></Grid.Column></Grid.Row>
                                        </Grid>
                                    </Segment>
                                </div>
                            )
                        }) : null}
                        <AddNewMeter/>
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        </Segment>);
    }

}

export default ReportContainer(Meters);


// WEBPACK FOOTER //
// ./src/views/report/meters.js